import React from 'react';
import OnboardingJourney from '../features/onboarding/OnboardingJourney';

/**
 * Full-screen talent profile onboarding — no app sidebar (dedicated journey UI).
 */
const Onboarding = () => <OnboardingJourney />;

export default Onboarding;
